import { render, staticRenderFns } from "./IconCp.vue?vue&type=template&id=58244fee&"
import script from "./IconCp.vue?vue&type=script&lang=js&"
export * from "./IconCp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports